import { Button, Flex } from '@shared/components';
import { z } from 'zod';

import { FormQIdField } from '../form-qid-field';

export const QIdSearchFormSchema = z.object({
  qIds: z.array(z.string()).max(10, 'ใส่ QID ได้สูงสุด 10 ตัว'),
});

export type QIdSearchFormInput = z.infer<typeof QIdSearchFormSchema>;

interface QIdSearchFormProps {
  loading?: boolean;
  onClear: () => void;
}

export default function QIdSearchForm(props: Readonly<QIdSearchFormProps>) {
  const { loading: isLoading, onClear } = props;

  return (
    <Flex sx={{ gap: (theme) => theme.spacing(4), flexDirection: 'column' }}>
      <FormQIdField name='qIds' limitTags={2} onClear={onClear} />
      <Button loading={isLoading} size='large' fullWidth type='submit'>
        ค้นหาด้วย QID
      </Button>
    </Flex>
  );
}
